import script from "./webApp.vue?vue&type=script&setup=true&lang=js"
export * from "./webApp.vue?vue&type=script&setup=true&lang=js"

import "./webApp.vue?vue&type=style&index=0&id=770040b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770040b8"]])

export default __exports__